import React from 'react';
import { PDFViewer, PDFSlideViewer } from '../PDFViewer';
import { download_file } from '../../utils/utils';

/**
 * Download / View Notes tab: PDF download button (if allowed) and viewer.
 */
export function DocumentationTab({ pdfLink, title, downloadablePdf, horizontalPdf }) {
  if (!pdfLink) return null;

  return (
    <>
      {downloadablePdf && (
        <button
          className="button my-1"
          onClick={() => download_file(pdfLink, title)}
        >
          Download PDF
        </button>
      )}
      {horizontalPdf ? (
        <PDFSlideViewer url={pdfLink} hideWaterMark />
      ) : (
        <PDFViewer url={pdfLink} hideWaterMark toolbar={false} />
      )}
    </>
  );
}
